export const title = "Roshita - Portfolio";
export const loadingTitle = "Loading...";
